import React from "react";

import { useNavigate } from "react-router-dom";

import { ModalComunicaciones } from "components/Portfolio/Lista/Comunicaciones/Row/Comunicaciones";
import { getIteByIdThunk } from "store/ITE/thunks";
import { getComunicacionesPendientesThunk } from "store/portfolio/thunks";
import { useAppDispatch, useAppSelector } from "store/store";

export const ComunicacionesActivo: React.FC = () => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const iteSelected = useAppSelector((state) => state.ites.iteSelected);
	const iteId = iteSelected.data?.ite.id;

	const onComunicacionesActualizadas = () => {
		if (iteId) dispatch(getIteByIdThunk({ id: iteId }));
		dispatch(getComunicacionesPendientesThunk());
	};

	return (
		<ModalComunicaciones
			asset={iteSelected.data?.asset}
			onClose={() => navigate(-1)}
			type="comunicaciones"
			onComunicacionesActualizadas={onComunicacionesActualizadas}
		/>
	);
};
